import React, { useState, useEffect } from "react";
import { css } from "@emotion/react";

export const pulsatingTextStyle = css`
  font-size: 1.75rem;
  font-weight: 600;
  text-align: center;
  padding: 2rem;
  background: linear-gradient(to right, rgb(154, 83, 229), #4a8fe3, #20c997, #4a8fe3, #9d5de0);
  background-size: 200% 100%;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  animation: moveGradient 2s linear infinite alternate;
  
  @keyframes moveGradient {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 100% 50%;
    }
  }
`;

export const loadingDotsContainerStyle = css`
  display: inline-block;
  width: 36px;
  text-align: left;
`;

interface GradientLoadingTextProps {
  text: string;
  fontSize?: string;
  padding?: string;
}

export const AnimatedDots: React.FC = () => {
  const [dots, setDots] = useState("");
  
  useEffect(() => {
    const dotSequence = ["", ".", "..", "..."];
    let currentIndex = 0;
    
    const interval = setInterval(() => {
      setDots(dotSequence[currentIndex]);
      currentIndex = (currentIndex + 1) % dotSequence.length;
    }, 500);
    
    return () => clearInterval(interval);
  }, []);
  
  const dotStyle = css`
    color: transparent;
    background: linear-gradient(to right, rgb(154, 83, 229), #4a8fe3, #20c997, #4a8fe3, #9d5de0);
    background-size: 200% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    animation: moveGradient 2s linear infinite alternate;
  `;
  
  return <span css={dotStyle}>{dots}</span>;
};

export const GradientLoadingText: React.FC<GradientLoadingTextProps> = ({ 
  text,
  fontSize = "1.75rem",
  padding = "2rem"
}) => {
  const customPulsatingTextStyle = css`
    ${pulsatingTextStyle}
    font-size: ${fontSize};
    padding: ${padding};
  `;

  return (
    <div css={customPulsatingTextStyle}>
      {text}<span css={loadingDotsContainerStyle}><AnimatedDots /></span>
    </div>
  );
};
